import React from "react";
import { connect } from "react-redux";
import { AppState } from "../../../redux";
import { SetProfileStateAction, SetProfileStatePayload, ProfileModuleState } from "../redux/profile/types";
import { setProfileState } from "../redux/profile/actions";
import { SpotlightsField } from "../../../react-components/page-framework/spotlights-field";
import { GRAPHQL_TYPE_ENTITY } from "@radivision/graphql";

interface MapStateProps {
  spotlights: string[];
  isCompany: boolean;
}

interface MapDispatchProps {
  setProfileState: (payload: SetProfileStatePayload) => SetProfileStateAction;
}

export type Props = MapDispatchProps & MapStateProps;

export const Component = (props: Props) => {
  const { spotlights, setProfileState, isCompany } = props;

  if (!isCompany) return null;

  return <SpotlightsField value={spotlights} onChange={(value) => setProfileState({ spotlights: value })} />;
};

const mapState = (state: AppState & ProfileModuleState) => {
  return {
    spotlights: state.profile.spotlights,
    isCompany: state.profile.type === GRAPHQL_TYPE_ENTITY,
  };
};

const mapDispatch = {
  setProfileState: setProfileState,
};

export const CompanySpotlights = connect(mapState, mapDispatch)(Component);
